import { render, staticRenderFns } from "./CommunicationManagementIndex.vue?vue&type=template&id=661344a4&scoped=true&"
import script from "./CommunicationManagementIndex.vue?vue&type=script&lang=js&"
export * from "./CommunicationManagementIndex.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationManagementIndex.vue?vue&type=style&index=0&id=661344a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661344a4",
  null
  
)

export default component.exports